module.exports = __webpack_public_path__ + "img/realbricks.ea5c893b.svg";